<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          گزارش بدهی ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col
              cols="12"
              md="3">
            <v-autocomplete
                :items="buildingList"
                v-model="buildingId"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('buildingId')"
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />

          </v-col>

          <v-col
              cols="12"
              md="3">
            <v-text-field v-model="amountFrom" dense outlined label="مبلغ از" type="number" :error-messages="getError('amountFrom')"/>
          </v-col>
          <v-col
              cols="12"
              md="3">
            <v-text-field v-model="amountTo" dense outlined label="مبلغ تا" type="number" :error-messages="getError('amountTo')"/>
          </v-col>
          <v-col
              cols="12"
              md="2" class="d-inline-flex">
            <v-btn small fab color="primary" @click="search">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>
            <v-btn v-if="dataItems && dataItems.length>0" class="mr-1" small fab color="error" @click="createPdf">
              <v-icon>mdi-file-pdf</v-icon>
            </v-btn>
          </v-col>

        </v-row>


        <v-spacer/>
      </v-card-text>
      <v-card-text>
        <b-table
            :items="dataItems"
            :fields="columns"
            show-empty
            sticky-header="450px"
            id="style-1"
            striped>

        </b-table>

      </v-card-text>
      <VueHtml2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :paginate-elements-by-height="700"
          filename="filename"
          :pdf-quality="2"
          :manual-pagination="true"
          pdf-format="a4"
          :html-to-pdf-options="htmlToPdfOptions"
          ref="html2Pdf">

        <section slot="pdf-content"  >

          <div class="container-fluid" style="direction: rtl">
            <!--          header-->
            <div style="margin: 5px; border: 1px solid grey">
              <p style="text-align:right;">
                              <span style="float:left;margin-left: 8px;margin-top: 5px">  <span
                                  class="text-muted">تاریخ گزارش:</span>  {{ nowDate }}</span>
                <span style="font-size: 18px; margin-right: 8px;margin-top: 5px">
                گزارش بدهی ها
              </span>
              </p>
            </div>
            <!--          header-->



            <!--          body-->
            <form v-for="(items,j) in pdfItems" :key="j">
              <section class="pdf-item" >
                <div class="container-fluid">
                  <div class="row p-2" style="margin-top: 20px">
                    <div class="col-12" >
<!--                      <table id="myTable" >-->
<!--                        <thead>-->
<!--                        <tr class="header">-->
<!--                          <th class="text-right">نام شخص</th>-->
<!--                          <th class="text-right">نام مجتمع</th>-->
<!--                          <th class="text-right">نام واحد</th>-->
<!--                          <th class="text-right">مبلغ</th>-->

<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                        <tr v-for="(item ,i) in items" :key="i">-->
<!--                          <td class="text-right">{{ item.fullName }}</td>-->
<!--                          <td class="text-right">{{ item.buildingName }}</td>-->
<!--                          <td class="text-right">{{ item.unitName }}</td>-->
<!--                          <td class="text-right">{{ item.sumRemainder }}</td>-->
<!--                        </tr>-->
<!--                        </tbody>-->

<!--                      </table>-->
                      <b-table

                          :items="items"
                          :fields="columns"
                          :per-page=0
                          stacked="md"
                          show-empty
                          striped
                          no-provider-paging
                      ></b-table>
                    </div>


                  </div>
                </div>
              </section>
              <div class="html2pdf__page-break"/>

            </form>
            <!--          body-->
          </div>

        </section>
      </VueHtml2pdf>
    </v-card>

  </div>
</template>

<script>
import Reporting from "@/views/reporting/debt/Reporting";
import {mapMutations} from "vuex";
import VueHtml2pdf from 'vue-html2pdf'
import persianDate  from 'persian-date'
export default {

  name: 'ReportDebt',
  components:{
    VueHtml2pdf
  },
  data() {
    return {
      buildingId: '',
      buildingList: [],
      amountFrom: '',
      amountTo: '',
      dataItems: [],
      pdfItems: [],
      bindingErrors: [],
     nowDate:'',
      columns: [
        {key: 'fullName', label: 'نام شخص',  },
        {key: 'buildingName', label: 'نام مجتمع ', },
        {key: 'unitName', label: 'نام واحد', },
        {key: 'lastUpdateDate', label: 'تاریخ بروزرسانی', },
        {key: 'date', label: 'تاریخ ثبت سند', },
        {key: 'sumRemainder', label: 'مبلغ(ریال)',sortable: true,sortDirection: 'desc',formatter: (value) => value.toLocaleString() },
      ],

      htmlToPdfOptions: {
        margin: [10,1,10,2],
      }

    };

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput(value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    fillDataItems() {
      Reporting.getPage().then(response => {
        this.buildingList = response.data.buildingList
      });
    },
    createPdf(){
     this.nowDate = new persianDate().format('YYYY/MM/DD')
      this.$refs.html2Pdf.generatePdf()
    },
    search() {
      this.dataItems = []
      this.bindingErrors = []
      this.$progress({message: 'درحال جستجو...'}, true)
      Reporting.search(this.buildingId, this.amountFrom, this.amountTo).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data.outList
          this.pdfItems = response.data.pdfList
        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })
    },

  },


  created() {
    this.fillDataItems()
    this.setDrawer(false)
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

#myTable {
  border-collapse: collapse; /* Collapse borders */
  width: 100%; /* Full-width */
  border: 1px solid #ddd; /* Add a grey border */
  font-size: 12px; /* Increase font-size */
}

#myTable th, #myTable td {
  text-align: left; /* Left-align text */
  padding: 8px; /* Add padding */
}

#myTable tr {
  /* Add a bottom border to all table rows */
  border-bottom: 1px solid #ddd;
}

#myTable tr.header, #myTable tr:hover {
  /* Add a grey background color to the table header and on hover */
  background-color: #f1f1f1;
  font-size: 12px;
}
#myTable thead, tfoot {
  display: table-row-group
}

</style>
